"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _profile = require("@widget/profile");

var _payouts = require("@module/payouts");

var _dialog = require("@package/dialog");

var _app = require("@package/app");

var _moment = _interopRequireDefault(require("@package/moment"));

var _numeral = _interopRequireDefault(require("@package/numeral"));

var _table = require("@package/table");

var _storybook = require("@pikassa/storybook");

var _dicts = require("@package/dicts");

var _utils = require("@package/utils");

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _Dates = _interopRequireDefault(require("./Dates"));

var _Description = _interopRequireDefault(require("./Description"));

var _StatusInfo = _interopRequireDefault(require("./StatusInfo"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function getCreatorName(details) {
  if (Array.isArray(details)) {
    var userNameDetail = details.find(function (detail) {
      return (detail === null || detail === void 0 ? void 0 : detail['name']) === 'userName';
    });
    return (userNameDetail === null || userNameDetail === void 0 ? void 0 : userNameDetail['value']) || '';
  }

  return '';
}

function checkPayoutPermission(value, permissions) {
  var _value$status;

  var hasCreatePayoutTwoFA = (0, _utils.checkPermission)(permissions, 'operation.payout.add');
  var statusCode = ((_value$status = value['status']) === null || _value$status === void 0 ? void 0 : _value$status['code']) === 5;
  return !!(hasCreatePayoutTwoFA && statusCode);
}

function TableComponent() {
  try {
    var handleExport = function handleExport() {
      var query = (0, _utils.queryToObject)(location['search']);
      dispatch((0, _payouts.exportPayouts)((0, _objectSpread2["default"])({
        order: 'created',
        dateFrom: (0, _moment["default"])().subtract(1, 'months').format('YYYY-MM-DD 00:00:00.000000+03:00'),
        dateTo: query['dateTo'] || (0, _moment["default"])().format('YYYY-MM-DD 23:59'),
        status: -1,
        externalId: query['externalId'] || null,
        amountFrom: null,
        amountTo: null,
        searchTerm: null,
        shopDemoMode: query['shopDemoMode'] || false
      }, query)));
    };

    var handleResetFilter = function handleResetFilter() {
      navigate(process.env['PUBLIC_URL'] + '/operations/payouts');
    };

    var handleGetDetails = function handleGetDetails(value) {
      navigate(process.env['PUBLIC_URL'] + '/operations/payouts/' + value);
    };

    var dispatch = (0, _reactRedux.useDispatch)();
    var navigate = (0, _reactRouterDom.useNavigate)();
    var location = (0, _reactRouterDom.useLocation)();
    var items = (0, _reactRedux.useSelector)(_payouts.selectItems);
    var meta = (0, _reactRedux.useSelector)(_payouts.selectMeta);
    var profile = (0, _reactRedux.useSelector)(_profile.selectProfile);
    var inExportProcess = (0, _reactRedux.useSelector)(_payouts.selectInExportProcess);
    var query = (0, _utils.queryToObject)(location['search']);
    var queryData = {
      dateFrom: query['dateFrom'] ? (0, _moment["default"])(query['dateFrom']).format('DD.MM.YYYY') : (0, _moment["default"])().subtract(1, 'months').format('DD.MM.YYYY'),
      dateTo: (0, _moment["default"])(query['dateTo'] || new Date()).format('DD.MM.YYYY')
    };
    var totalRow = (0, _numeral["default"])(meta['totalRow']).format('0,00');
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['header']
    }, /*#__PURE__*/_react["default"].createElement("span", {
      "data-locator": "payouts.header",
      className: _defaultModule["default"]['message']
    }, totalRow === '0' ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "\u041D\u0435\u0442 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0439 \u0434\u043B\u044F \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F") : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "\u041D\u0430\u0439\u0434\u0435\u043D\u043E ", totalRow, " ", (0, _utils.nounDeclension)(meta['totalRow'], ['операция', 'операции', 'операций'])), " \u0441 ", queryData['dateFrom'], " \u043F\u043E ", queryData['dateTo']), /*#__PURE__*/_react["default"].createElement("span", {
      "data-locator": "payouts.reset-filter",
      className: _defaultModule["default"]['link'],
      onClick: handleResetFilter
    }, "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u0444\u0438\u043B\u044C\u0442\u0440\u044B"), totalRow !== '0' && /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['controls']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Icon, {
      "data-locator": "payouts.export_button",
      icon: 'icon-csv',
      inProcess: inExportProcess,
      onClick: handleExport
    }))), totalRow !== '0' && /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['table']
    }, /*#__PURE__*/_react["default"].createElement(_table.Table, {
      _data: "payouts",
      columns: items
    }, /*#__PURE__*/_react["default"].createElement(_table.Column, {
      _data: "creation-date",
      title: "\u0414\u0430\u0442\u0430",
      width: "90",
      align: "left"
    }, function (value) {
      return /*#__PURE__*/_react["default"].createElement(_Dates["default"], value);
    }), /*#__PURE__*/_react["default"].createElement(_table.Column, {
      _data: "external-id",
      title: "\u041D\u043E\u043C\u0435\u0440 \u0432\u044B\u043F\u043B\u0430\u0442\u044B",
      alias: "externalId",
      align: "left"
    }, function (value) {
      return /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
        "data-locator": "payout.external-id"
      }, value);
    }), /*#__PURE__*/_react["default"].createElement(_table.Column, {
      _data: "shop-name",
      title: "\u041C\u0430\u0433\u0430\u0437\u0438\u043D",
      alias: "shop.name",
      align: "left"
    }, function (value) {
      return /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
        "data-locator": "payout.shop.name",
        type: 'body'
      }, value);
    }), /*#__PURE__*/_react["default"].createElement(_table.Column, {
      _data: "created-by-user-name",
      title: "\u0421\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A, \u0441\u043E\u0437\u0434\u0430\u0432\u0448\u0438\u0439 \u0432\u044B\u043F\u043B\u0430\u0442\u0443",
      alias: "details",
      align: "left"
    }, function (value) {
      return /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
        "data-locator": "payout.created-by-user-name",
        type: 'body'
      }, getCreatorName(value));
    }), /*#__PURE__*/_react["default"].createElement(_table.Column, {
      _data: "amount",
      title: "\u0421\u0443\u043C\u043C\u0430",
      align: "right",
      transform: function transform(value) {
        return "".concat(_utils.numbers.price(value['amount']), " ").concat(_dicts.CURRENCY_SYMBOLS[value['currency']] || '');
      }
    }, function (value) {
      return /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
        "data-locator": "payout.amount",
        type: 'body'
      }, value);
    }), /*#__PURE__*/_react["default"].createElement(_table.Column, {
      _data: "description",
      title: "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435",
      align: "left"
    }, function (value) {
      return /*#__PURE__*/_react["default"].createElement(_Description["default"], value);
    }), /*#__PURE__*/_react["default"].createElement(_table.Column, {
      _data: "status",
      title: "\u0421\u0442\u0430\u0442\u0443\u0441",
      width: "200",
      align: "left"
    }, function (value) {
      return /*#__PURE__*/_react["default"].createElement(_StatusInfo["default"], Object.assign({
        "data-locator": 'payout.status'
      }, value));
    }), /*#__PURE__*/_react["default"].createElement(_table.Column, {
      width: 60
    }, function (value) {
      var _profile$user;

      return /*#__PURE__*/_react["default"].createElement(_storybook.Settings, {
        _data: 'payouts',
        items: [checkPayoutPermission(value, profile === null || profile === void 0 ? void 0 : (_profile$user = profile['user']) === null || _profile$user === void 0 ? void 0 : _profile$user['permissions']) && {
          title: 'Ввести код',
          onClick: function onClick() {
            return dispatch((0, _dialog.openDialog)('confirm-twoFA', {
              id: value['id']
            }));
          },
          '_data': 'payout-token'
        }, {
          title: 'Информация',
          onClick: function onClick() {
            return (value === null || value === void 0 ? void 0 : value['uuid']) && handleGetDetails(value['uuid']);
          },
          '_data': 'payout-info'
        }]
      });
    }))));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = /*#__PURE__*/_react["default"].memo(TableComponent);

exports["default"] = _default;